import type { IconName } from '@hotjar/hotsauce';
import type { AllBadgeStatus } from '@hotjar/hotsauce/build/components/Badge/BaseBadge';
import type { ReactNode } from 'react';
import type { AbstractSingleFilterPillsProps } from '../../SingleFilterType';
import { GenericFilter } from '../GenericFilter/GenericFilter';
import type { Option } from './GenericRadioDropdown';
import { GenericRadioDropdown } from './GenericRadioDropdown';

interface GenericRadioFilterProps<T> extends AbstractSingleFilterPillsProps<T> {
  filterName: string;
  iconName: IconName;
  optionList: Option<T>[];
  label1?: string;
  label2?: string;
  header?: ReactNode;
  badge?: AllBadgeStatus;
  isDisabled?: boolean;
  disabledReason?: string;
}

export function GenericRadioFilter<T>({
  currentValue,
  autoFocus,
  optionalDefaultValue,
  onApply,
  onRemove,
  filterName,
  iconName,
  optionList,
  label1,
  label2,
  showDropdownOnMount,
  onDropdownHidden,
  onDropdownShown,
  isInactive,
  showDropdownCaret,
  header,
  badge,
  isDisabled,
  disabledReason,
}: GenericRadioFilterProps<T>): JSX.Element {
  const handleApply = (close: () => void, newValue?: T) => {
    onApply(newValue);
    close();
  };

  return (
    <GenericFilter
      autoFocus={autoFocus}
      filterName={filterName}
      label1={label1}
      label2={label2}
      iconName={iconName}
      onRemove={onRemove}
      showDropdownOnMount={showDropdownOnMount}
      onDropdownHidden={onDropdownHidden}
      onDropdownShown={onDropdownShown}
      isInactive={isInactive}
      showDropdownCaret={showDropdownCaret}
      badge={badge}
      isDisabled={isDisabled}
      disabledReason={disabledReason}
      renderDropdown={({ close }) => {
        return (
          <GenericRadioDropdown
            filterName={filterName}
            currentValue={currentValue}
            optionalDefaultValue={optionalDefaultValue}
            onApply={(newValue) => handleApply(close, newValue)}
            optionList={optionList}
            header={header}
          />
        );
      }}
    />
  );
}
